import type { ReactNode } from "react";

export type EmptyMessageProps = {
  title?: string;
  children?: ReactNode;
  className?: string;
};

/** Historical empty state (`ne__empty-message`). */
export function EmptyMessage({
  title,
  children,
  className = "",
}: EmptyMessageProps) {
  return (
    <div
      className={`ne__empty-message${className ? ` ${className}` : ""}`}
    >
      {title ? <h2>{title}</h2> : null}
      {children}
    </div>
  );
}
